import React, { useContext, useCallback } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { convertUndefinedFields } from 'utils/helpers';
import {
	IEditDishRestaurantPropertiesContext,
	EditDishRestaurantPropertiesContext,
} from '../../editDishRestaurantPropertiesState/editDishRestaurantPropertiesContext';
import { updateDishRestaurantProperties } from 'backend/dishes';
import { useHistory } from 'react-router-dom';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { SaveAsPatchModal } from './SaveAsPatchModal/index';
import { ModalAssignDishToSubcategoryOnRestaurant } from './ModalAssignDishToSubcategoryOnRestaurant';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const {
		changeTypeOfModalWindow,
		refetchRestPropsData,
		dataForSubmit,
		typeOfModalWindow,
		IDSelectedRestaurant,
		dishId,
	} = useContext<IEditDishRestaurantPropertiesContext>(EditDishRestaurantPropertiesContext);
	const history = useHistory();

	const handleConfirm = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await updateDishRestaurantProperties(convertedData);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForSubmit]);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, [changeTypeOfModalWindow]);

	const handleCloseModalWithRefetchRestPropsData = useCallback(() => {
		refetchRestPropsData(true);
		changeTypeOfModalWindow(null);
	}, [refetchRestPropsData, changeTypeOfModalWindow]);

	const handleCloseModalWithError = useCallback(() => {
		changeTypeOfModalWindow('error');
	}, [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			{typeOfModalWindow === 'toConfirmFieldsClearing' && (
				<ModalToConfirm
					onConsentEvent={() => history.push(`/menu-v2/dishes/view?dishID=${dishId}`)}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="cancelSaveInfo"
				/>
			)}
			{typeOfModalWindow === 'toConfirmSubmit' && (
				<ModalToConfirm
					onConsentEvent={handleConfirm}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="saveInfo"
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfully
					onConsentEvent={handleCloseModalWithRefetchRestPropsData}
					isVisible={true}
					description="savedSuccessfully"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError onConsentEvent={handleCloseModal} isVisible={true} description="errorWhileSaving" />
			)}
			{typeOfModalWindow === 'saveAsPatch' && (
				<SaveAsPatchModal onCloseModal={handleCloseModalWithRefetchRestPropsData} />
			)}
			{typeOfModalWindow === 'assignSubcategories' && IDSelectedRestaurant && (
				<ModalAssignDishToSubcategoryOnRestaurant
					onCloseModal={handleCloseModalWithRefetchRestPropsData}
					onFailureEvent={handleCloseModal}
					onShowError={handleCloseModalWithError}
					dishId={dishId}
					IDSelectedRestaurant={IDSelectedRestaurant}
				/>
			)}
		</ModalWrapper>
	);
};
